/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });

    // Add click outside event listener to close suggestions
    document.addEventListener('click', (event) => {
      this.handleClickOutside(event);
    });
  }

  handleClickOutside(event) {
    // Check if click is outside the search container
    if (!this.container.contains(event.target) && 
        !event.target.closest('.thb-quick-search')) {
      
      // Close the predictive search results
      if (this.predictiveSearchResults.classList.contains('active')) {
        this.predictiveSearchResults.classList.remove('active');
        // Clear the content
        this.predictiveSearchResults.innerHTML = '';
      }
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      // Clear content when search term is empty
      this.predictiveSearchResults.innerHTML = '';
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearchResults.classList.add('loading');

    // Use regular search API instead of predictive search for better blog/article results
    fetch(`/search?q=${encodeURIComponent(searchTerm)}&type=article,page&view=ajax`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          // Fallback to predictive search if regular search fails
          return this.getFallbackPredictiveSearch(searchTerm);
        }
        return response.text();
      })
      .then((text) => {
        if (text) {
          this.renderCustomSearchResults(text, searchTerm);
        }
      })
      .catch((error) => {
        this.predictiveSearchResults.classList.remove('loading');
        console.error('Search error:', error);
        // Fallback to predictive search
        this.getFallbackPredictiveSearch(searchTerm);
      });
  }

  getFallbackPredictiveSearch(searchTerm) {
    // Fallback to the original predictive search
    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Predictive search failed');
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.renderNoResults(searchTerm);
      });
  }

  renderCustomSearchResults(searchResults, searchTerm) {
    // Parse the search results and create our custom markup
    const parser = new DOMParser();
    const doc = parser.parseFromString(searchResults, 'text/html');
    
    // Extract articles and pages from the search results
    const articles = doc.querySelectorAll('[data-search-type="article"]') || [];
    const pages = doc.querySelectorAll('[data-search-type="page"]') || [];
    
    let resultsMarkup = `
      <side-panel-content-tabs class="side-panel-content--tabs">
        <button class="tab-active">Content (${articles.length + pages.length})</button>
      </side-panel-content-tabs>
      <scroll-shadow>
        <div class="side-panel-content--inner">
          <div class="side-panel-content--tab-panel tab-active">
    `;

    // Process articles
    articles.forEach(article => {
      const title = article.querySelector('h3, .article-title, a')?.textContent?.trim() || 'Untitled';
      const url = article.querySelector('a')?.href || '#';
      const excerpt = article.querySelector('.article-excerpt, .summary, p')?.textContent?.trim() || '';
      const image = article.querySelector('img')?.src || '';
      
      resultsMarkup += `
        <div class="product-cart-item">
       
          <div class="search-item-content">
            <a href="${url}" class="cart-product-link">${this.highlightSearchTerm(title, searchTerm)}</a>
   
            ${excerpt ? `<p class="search-item-excerpt">${this.highlightSearchTerm(excerpt.substring(0, 100), searchTerm)}${excerpt.length > 100 ? '...' : ''}</p>` : ''}
          </div>
        </div>
      `;
    });

    // Process pages
    pages.forEach(page => {
      const title = page.querySelector('h3, .page-title, a')?.textContent?.trim() || 'Untitled';
      const url = page.querySelector('a')?.href || '#';
      const excerpt = page.querySelector('.page-excerpt, .summary, p')?.textContent?.trim() || '';
      
      resultsMarkup += `
        <div class="product-cart-item">
       
          <div class="search-item-content">
            <a href="${url}" class="cart-product-link">${this.highlightSearchTerm(title, searchTerm)}</a>
      
            ${excerpt ? `<p class="search-item-excerpt">${this.highlightSearchTerm(excerpt.substring(0, 100), searchTerm)}${excerpt.length > 100 ? '...' : ''}</p>` : ''}
          </div>
        </div>
      `;
    });

    resultsMarkup += `
          </div>
        </div>
      </scroll-shadow>

    `;

    this.predictiveSearchResults.innerHTML = resultsMarkup;

    // Set up the view all button
    const submitButton = this.predictiveSearchResults.querySelector('#search-results-submit');
    if (submitButton) {
      submitButton.addEventListener('click', () => {
        this.form.submit();
      });
    }
  }

  highlightSearchTerm(text, searchTerm) {
    if (!searchTerm || !text) return text;
    
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    // Initialize tabs functionality
    this.initializeTabs();

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        _this.form.submit();
      });
    }
  }

  renderNoResults(searchTerm) {
    this.predictiveSearchResults.innerHTML = `
      <div class="side-panel-content--inner">
        <div class="no-search-results">
          <p>No content found for "<strong>${searchTerm}</strong>"</p>
          <p><small>Try different keywords or check spelling</small></p>
        </div>
      </div>
    `;
  }

  initializeTabs() {
    const tabs = this.predictiveSearchResults.querySelectorAll('.side-panel-content--tabs button');
    const panels = this.predictiveSearchResults.querySelectorAll('.side-panel-content--tab-panel');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        // Remove active class from all tabs and panels
        tabs.forEach(t => t.classList.remove('tab-active'));
        panels.forEach(p => p.classList.remove('tab-active'));

        // Add active class to clicked tab and corresponding panel
        tab.classList.add('tab-active');
        if (panels[index]) {
          panels[index].classList.add('tab-active');
        }
      });
    });
  }

  close() {
    this.container.classList.remove('active');
    // Also close the predictive search results when closing the entire search
    this.predictiveSearchResults.classList.remove('active');
    // Clear the content
    this.predictiveSearchResults.innerHTML = '';
  }
}

window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});